var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "errorContainer",
    { attrs: { error: _vm.erreur, warning: _vm.warning } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              class: `${_vm.$screen.width >= 992 ? "my-1" : "my-2"}`,
              attrs: { cols: `${_vm.$screen.width >= 992 ? 8 : 10}` },
            },
            [
              _c("h4", [
                _vm._v(_vm._s(_vm.selectedMenu ? _vm.selectedMenu.text : "")),
              ]),
            ]
          ),
          _c(
            "b-col",
            { attrs: { cols: `${_vm.$screen.width >= 992 ? 4 : 2}` } },
            [
              _c(
                "b-row",
                {
                  class: `${
                    _vm.$screen.width >= 992
                      ? "pull-right big-menu"
                      : "pull-right small-menu"
                  }`,
                },
                [_c("SectionMenu", { attrs: { menus: _vm.menus } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.menuId === 1314
        ? _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("p"),
                _c("p", [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        this.FormMSG(
                          4,
                          `To successfully complete a carbon action plan in the UK your production must be carbon neutral. If your production has not been commissioned in the UK you can still complete the carbon action plan and you can chose whether to offset the remaining emissions.`
                        )
                      ) +
                      "\n\t\t\t"
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        this.FormMSG(
                          2,
                          `To achieve carbon neutrality you should decarbonise your production as much as possible through choosing renewable energy, electric transport etc. and then you will need to offset the rest. You can offset through albert or through another reputable offsetting project. Visit our offsetting page for more info.`
                        )
                      ) +
                      "\n\t\t\t"
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        this.FormMSG(
                          3,
                          `Offsetting typically costs 0.1% of a production's budget but it's important that you complete a draft footprint so you know how much to budget for offsetting and the areas in which you might be able to reduce your impact.`
                        )
                      ) +
                      "\n\t\t\t"
                  ),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-card",
                _vm._l(_vm.items, function (item, i) {
                  return _c("SectionQuiz", {
                    key: item.value,
                    attrs: {
                      item: item,
                      end: _vm.items.length - 1 === i,
                      subItems: _vm.getAlbertSubActionsById(
                        _vm.menuId,
                        item.value
                      ),
                      quiz: _vm.quiz,
                      menuId: _vm.menuId,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }